const config = {
  merchant: "tcglive",
  language: "CN",
};
export default config;
